import React, { createContext, useContext, useState, ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';

interface AppContextProps {
  // Theme Management
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  
  // User Preferences
  language: string;
  setLanguage: (lang: string) => void;
  
  // Application State
  isMenuOpen: boolean;
  toggleMenu: () => void;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [language, setLanguage] = useState('de');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    // Hier könnte man die Theme-Klasse im HTML-Element ändern
    if (!isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const value = {
    isDarkMode,
    toggleDarkMode,
    language,
    setLanguage,
    isMenuOpen,
    toggleMenu
  };
  
  return (
    <AppContext.Provider value={value}>
      <HelmetProvider>
        {children}
      </HelmetProvider>
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }
  return context;
}; 